import { render, staticRenderFns } from "./RejectProductsModal.vue?vue&type=template&id=7bd1b51d"
import script from "./RejectProductsModal.vue?vue&type=script&lang=js"
export * from "./RejectProductsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports